module.exports = __webpack_public_path__ + "media/Finale1.41b17ed9.mp3";